import React from 'react'
import styled from '@emotion/styled'
import { IHeaderParams, GridApi } from 'ag-grid-community'
import { Tooltip } from 'view/components/tooltip'
import { Locale, Translation } from 'locale'
import { arrowUpDownIcon } from '../styles/gridIconSet'
import * as constants from 'view/styles/constants'

interface GroupHeaderRendererProps extends IHeaderParams {}

interface GroupHeaderRendererState {
  allCollapsed: boolean
}

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  font-weight: ${constants.FontWeight.Bold};
  color: ${constants.CORE_PRIMARY_6};
`

const ExpandGroupsToggle = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`

export class GroupHeaderRenderer extends React.Component<GroupHeaderRendererProps, GroupHeaderRendererState> {
  state = {
    allCollapsed: false
  }

  render() {
    return (
      <Tooltip tooltip={Locale.translate(Translation.SC_EXPAND_COLLAPSE_ALL_ROWS)}>
        <Container onClick={this.onClick}>
          <ExpandGroupsToggle>{arrowUpDownIcon}</ExpandGroupsToggle>
          {this.props.column.getColDef().headerName}
        </Container>
      </Tooltip>
    )
  }

  private onClick = () => {
    const gridApi: GridApi = this.props.api
    if (this.state.allCollapsed) {
      gridApi.expandAll()
      this.setState({ allCollapsed: false })
    } else {
      gridApi.collapseAll()
      this.setState({ allCollapsed: true })
    }
  }
}
